jQuery(document).ready(function ($) {
  if (typeof pageafurb !== 'undefined') {
    var timelines = $('.aftl'),
      eventsMinDistance = 50; //altera a distância entre os elementos da tl.

    (timelines.length > 0) && initTimeline(timelines);

    function initTimeline(timelines) {
      timelines.each(function () {
        var timeline = $(this),
          timelineComponents = {};
        //cache timeline components
        timelineComponents['timelineWrapper'] = timeline.find('.aftl__wrapper');
        timelineComponents['datasWrapper'] = timelineComponents['timelineWrapper'].children('.aftl__datas');
        timelineComponents['fillingLine'] = timelineComponents['datasWrapper'].children('.filling-line');
        timelineComponents['timelineEvents'] = timelineComponents['datasWrapper'].find('a');
        timelineComponents['timelineDates'] = parseDate(timelineComponents['timelineEvents']);
        timelineComponents['eventsMinLapse'] = minLapse(timelineComponents['timelineDates']);
        timelineComponents['timelineNavigation'] = timeline.find('.aftl__navigation');
        timelineComponents['eventsContent'] = timeline.children('.aftl__datas-content');

        //assign a left postion to the single events along the timeline
        setDatePosition(timelineComponents, eventsMinDistance);
        //assign a width to the timeline
        var timelineTotWidth = setTimelineWidth(timelineComponents, eventsMinDistance);
        //the timeline has been initialize - show it
        timeline.addClass('loaded');

        //detect click on the next arrow
        timelineComponents['timelineNavigation'].on('click', '.next', function (event) {
          event.preventDefault();
          updateSlide(timelineComponents, timelineTotWidth, 'next');
        });
        //detect click on the prev arrow
        timelineComponents['timelineNavigation'].on('click', '.prev', function (event) {
          event.preventDefault();
          updateSlide(timelineComponents, timelineTotWidth, 'prev');
        });
        //detect click on the a single event - show new event content
        timelineComponents['datasWrapper'].on('click', 'a', function (event) {
          event.preventDefault();
          timelineComponents['timelineEvents'].removeClass('selected');
          $(this).addClass('selected');
          updateOlderEvents($(this));
          checkSelected();
          updateFilling($(this), timelineComponents['fillingLine'], timelineTotWidth);
          updateVisibleContent($(this), timelineComponents['eventsContent']);
        });

        //on swipe, show next/prev event content
        timelineComponents['eventsContent'].on('swipeleft', function () {
          var mq = checkMQ();
          (mq == 'mobile') && showNewContent(timelineComponents, timelineTotWidth, 'next');
        });
        timelineComponents['eventsContent'].on('swiperight', function () {
          var mq = checkMQ();
          (mq == 'mobile') && showNewContent(timelineComponents, timelineTotWidth, 'prev');
        });

        //keyboard navigation
        $(document).keyup(function (event) {
          if (event.which == '37' && elementInViewport(timeline.get(0))) {
            showNewContent(timelineComponents, timelineTotWidth, 'prev');
          } else if (event.which == '39' && elementInViewport(timeline.get(0))) {
            showNewContent(timelineComponents, timelineTotWidth, 'next');
          }
        });
      });
    }

    function resetEventsSpots() {
      $('.events-spot-active').removeClass('events-spot-active').addClass('events-spot');
    }

    function checkSelected() {
      var selected = $('.selected');
      if (selected.length) {
        selected.find('.events-spot').removeClass('events-spot').addClass('events-spot-active');
      }
    }

    function updateSlide(timelineComponents, timelineTotWidth, string) {
      //retrieve translateX value of timelineComponents['datasWrapper']
      var translateValue = getTranslateValue(timelineComponents['datasWrapper']),
        wrapperWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', ''));
      //translate the timeline to the left('next')/right('prev')
      (string == 'next')
        ? translateTimeline(timelineComponents, translateValue - wrapperWidth + eventsMinDistance, wrapperWidth - timelineTotWidth)
        : translateTimeline(timelineComponents, translateValue + wrapperWidth - eventsMinDistance);
    }

    function showNewContent(timelineComponents, timelineTotWidth, string) {
      //go from one event to the next/previous one
      var visibleContent = timelineComponents['eventsContent'].find('.selected'),
        newContent = (string == 'next') ? visibleContent.next() : visibleContent.prev();

      if (newContent.length > 0) { //if there's a next/prev event - show it
        var selectedDate = timelineComponents['datasWrapper'].find('.selected'),
          newEvent = (string == 'next') ? selectedDate.parent('li').next('li').children('a') : selectedDate.parent('li').prev('li').children('a');

        updateFilling(newEvent, timelineComponents['fillingLine'], timelineTotWidth);
        updateVisibleContent(newEvent, timelineComponents['eventsContent']);
        newEvent.addClass('selected');
        selectedDate.removeClass('selected');
        updateOlderEvents(newEvent);
        updateTimelinePosition(string, newEvent, timelineComponents, timelineTotWidth);
      }
    }

    function updateTimelinePosition(string, event, timelineComponents, timelineTotWidth) {
      //translate timeline to the left/right according to the position of the selected event
      var eventStyle = window.getComputedStyle(event.get(0), null),
        eventLeft = Number(eventStyle.getPropertyValue("left").replace('px', '')),
        timelineWidth = Number(timelineComponents['timelineWrapper'].css('width').replace('px', '')),
        timelineTotWidth = Number(timelineComponents['datasWrapper'].css('width').replace('px', ''));
      var timelineTranslate = getTranslateValue(timelineComponents['datasWrapper']);

      if ((string == 'next' && eventLeft > timelineWidth - timelineTranslate) || (string == 'prev' && eventLeft < -timelineTranslate)) {
        translateTimeline(timelineComponents, -eventLeft + timelineWidth / 2, timelineWidth - timelineTotWidth);
      }
    }

    function translateTimeline(timelineComponents, value, totWidth) {
      var datasWrapper = timelineComponents['datasWrapper'].get(0);
      value = (value > 0) ? 0 : value; //only negative translate value
      value = (!(typeof totWidth === 'undefined') && value < totWidth) ? totWidth : value; //do not translate more than timeline width
      setTransformValue(datasWrapper, 'translateX', value + 'px');
      //update navigation arrows visibility
      (value == 0) ? timelineComponents['timelineNavigation'].find('.prev').addClass('inactive') : timelineComponents['timelineNavigation'].find('.prev').removeClass('inactive');
      (value == totWidth) ? timelineComponents['timelineNavigation'].find('.next').addClass('inactive') : timelineComponents['timelineNavigation'].find('.next').removeClass('inactive');
    }

    function updateFilling(selectedEvent, filling, totWidth) {
      //change .filling-line length according to the selected event
      var eventStyle = window.getComputedStyle(selectedEvent.get(0), null),
        eventLeft = eventStyle.getPropertyValue("left"),
        eventWidth = eventStyle.getPropertyValue("width");
      eventLeft = Number(eventLeft.replace('px', '')) + Number(eventWidth.replace('px', '')) / 2;
      var scaleValue = eventLeft / totWidth;
      setTransformValue(filling.get(0), 'scaleX', scaleValue);
    }

    function setDatePosition(timelineComponents, min) {
      for (i = 0; i < timelineComponents['timelineDates'].length; i++) {
        var distance = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][i]),
          distanceNorm = Math.round(distance / timelineComponents['eventsMinLapse']) + 2;
        timelineComponents['timelineEvents'].eq(i).css('left', distanceNorm * min + 'px');
      }
    }

    function setTimelineWidth(timelineComponents, width) {
      var timeSpan = daydiff(timelineComponents['timelineDates'][0], timelineComponents['timelineDates'][timelineComponents['timelineDates'].length - 1]),
        timeSpanNorm = timeSpan / timelineComponents['eventsMinLapse'],
        timeSpanNorm = Math.round(timeSpanNorm) + 4,
        totalWidth = timeSpanNorm * width;
      timelineComponents['datasWrapper'].css('width', totalWidth + 'px');
      updateFilling(timelineComponents['timelineEvents'].eq(0), timelineComponents['fillingLine'], totalWidth);

      return totalWidth;
    }

    function updateVisibleContent(event, eventsContent) {
      var eventDate = event.data('date'),
        visibleContent = eventsContent.find('.selected'),
        selectedContent = eventsContent.find('[data-date="' + eventDate + '"]'),
        selectedContentHeight = selectedContent.height();

      if (selectedContent.index() > visibleContent.index()) {
        var classEnetering = 'selected enter-right',
          classLeaving = 'leave-left';
      } else {
        var classEnetering = 'selected enter-left',
          classLeaving = 'leave-right';
      }

      selectedContent.attr('class', classEnetering);
      visibleContent.attr('class', classLeaving).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
        visibleContent.removeClass('leave-right leave-left');
        selectedContent.removeClass('enter-left enter-right');
      });
      eventsContent.css('height', selectedContentHeight + 'px');
    }

    function updateOlderEvents(event) {
      event.parent('li').prevAll('li').children('a').addClass('older-event').end().end().nextAll('li').children('a').removeClass('older-event')
      resetEventsSpots();
    }

    function getTranslateValue(timeline) {
      var timelineStyle = window.getComputedStyle(timeline.get(0), null),
        timelineTranslate = timelineStyle.getPropertyValue("-webkit-transform") ||
          timelineStyle.getPropertyValue("-moz-transform") ||
          timelineStyle.getPropertyValue("-ms-transform") ||
          timelineStyle.getPropertyValue("-o-transform") ||
          timelineStyle.getPropertyValue("transform");

      if (timelineTranslate.indexOf('(') >= 0) {
        var timelineTranslate = timelineTranslate.split('(')[1];
        timelineTranslate = timelineTranslate.split(')')[0];
        timelineTranslate = timelineTranslate.split(',');
        var translateValue = timelineTranslate[4];
      } else {
        var translateValue = 0;
      }

      return Number(translateValue);
    }

    function setTransformValue(element, property, value) {
      element.style["-webkit-transform"] = property + "(" + value + ")";
      element.style["-moz-transform"] = property + "(" + value + ")";
      element.style["-ms-transform"] = property + "(" + value + ")";
      element.style["-o-transform"] = property + "(" + value + ")";
      element.style["transform"] = property + "(" + value + ")";
    }

    //based on http://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
    function parseDate(events) {
      var dateArrays = [];
      events.each(function () {
        var dateComp = $(this).data('date').split('/'),
          newDate = new Date(dateComp[2], dateComp[1] - 1, dateComp[0]);
        dateArrays.push(newDate);
      });
      return dateArrays;
    }

    function parseDate2(events) {
      var dateArrays = [];
      events.each(function () {
        var singleDate = $(this),
          dateComp = singleDate.data('date').split('T');
        if (dateComp.length > 1) { //both DD/MM/YEAR and time are provided
          var dayComp = dateComp[0].split('/'),
            timeComp = dateComp[1].split(':');
        } else if (dateComp[0].indexOf(':') >= 0) { //only time is provide
          var dayComp = ["2000", "0", "0"],
            timeComp = dateComp[0].split(':');
        } else { //only DD/MM/YEAR
          var dayComp = dateComp[0].split('/'),
            timeComp = ["0", "0"];
        }
        var newDate = new Date(dayComp[2], dayComp[1] - 1, dayComp[0], timeComp[0], timeComp[1]);
        dateArrays.push(newDate);
      });
      return dateArrays;
    }

    function daydiff(first, second) {
      return Math.round((second - first));
    }

    function minLapse(dates) {
      //determine the minimum distance among events
      var dateDistances = [];
      for (i = 1; i < dates.length; i++) {
        var distance = daydiff(dates[i - 1], dates[i]);

        dateDistances.push(distance);
      }
      return Math.min.apply(null, dateDistances);
    }

    /*
      How to tell if a DOM element is visible in the current viewport?
      http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
    */
    function elementInViewport(el) {
      var top = el.offsetTop;
      var left = el.offsetLeft;
      var width = el.offsetWidth;
      var height = el.offsetHeight;

      while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
      }

      return (
        top < (window.pageYOffset + window.innerHeight) &&
        left < (window.pageXOffset + window.innerWidth) &&
        (top + height) > window.pageYOffset &&
        (left + width) > window.pageXOffset
      );
    }

    function checkMQ() {
      //check if mobile or desktop device
      return window.getComputedStyle(document.querySelector('.aftl'), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "");
    }

    $('[data-toggle="collapse.show"]').on('click', function (event) {
      event.preventDefault();
      $($(this).data('target') || $(this).attr('href')).collapse('show');
      $(this).removeClass('collapsed');
      $([...this.classList].map(e => `.${e}`).join(' ')).not(this).addClass('collapsed');
    })

    $('.afl__accordion-header').click(function () {
      $(this).find('i').toggleClass('fa-plus-square-o fa-minus-square-o');
    })

    $('.campus-image').click(function () {
      $('.afl__details-container').addClass('show').addClass('slide-in-right');
    })
    $('.afl__details-close').click(function () {
      $('.afl__details-container').removeClass('slide-in-right')
        .addClass('slide-out-right')
        .one('transitionend', function () {
          $(this).removeClass('slide-out-right')
            .removeClass('show')
        });
    })
    checkSelected()

    // contacts section //
    // var select = document.querySelector(".nice-select[tabindex='0']");
    // var current = select.querySelector(".nice-select[tabindex='0'] > .current");
    // var lista = select.querySelector(".nice-select[tabindex='0'] > .list");
    //
    // // add event listener for when the select value changes
    // function changelist() {
    //   var inputEvent = new Event('input');
    //   searchInput.dispatchEvent(inputEvent);
    //   var selectedOption = lista.querySelector('.selected').getAttribute('data-value');
    //   var contactDivs = document.querySelectorAll('.contacts div[id^="contact-"]');
    //   if (selectedOption == 0) {
    //     for (let i = 0; i < contactDivs.length; i++) {
    //       contactDivs[i].style.display = 'block';
    //
    //     }
    //     return
    //   }
    //   // loop through all the contact divs
    //
    //   for (let i = 0; i < contactDivs.length; i++) {
    //     // if the div id contains the selected option value, display it, otherwise hide it
    //     if (contactDivs[i].id === 'contact-' + selectedOption) {
    //       contactDivs[i].style.display = 'block';
    //     } else {
    //       contactDivs[i].style.display = 'none';
    //     }
    //   }
    // }
    //
    // lista.addEventListener('click', function (event) {
    //   setTimeout(function () {
    //     changelist();
    //     changelist();
    //   }, 100)
    //
    // });
    //contact search
    // const searchInput = document.querySelector('input[name="busca"]');
    // const contacts = document.querySelectorAll('.search');
    // const contactsps = document.querySelectorAll('.search p');
    // const titles = document.querySelectorAll('.title');
    //
    // function removeAccents(str) {
    //   return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    // }
    //
    // function searchParagraphs(event) {
    //   contactsps.forEach(contactsp => contactsp.style.display = '');
    //
    //   const searchTerm = removeAccents(event.target.value.toLowerCase());
    //
    //   contacts.forEach(contact => {
    //     const paragraphs = Array.from(contact.querySelectorAll('p'));
    //     const matches = paragraphs.filter(p => removeAccents(p.innerText.toLowerCase()).includes(searchTerm));
    //     const title = contact.previousElementSibling;
    //
    //     if (matches.length > 0) {
    //       contact.style.display = '';
    //       title.style.display = '';
    //
    //       paragraphs.forEach(p => {
    //         if (matches.includes(p)) {
    //           p.style.display = '';
    //         } else {
    //           p.style.display = 'none';
    //         }
    //       });
    //     } else {
    //       contact.style.display = 'none';
    //       title.style.display = 'none';
    //     }
    //   });
    //
    //   const visibleContacts = Array.from(contacts).filter(c => c.style.display !== 'none');
    //   titles.forEach(title => {
    //     const searchDivs = Array.from(title.parentElement.querySelectorAll('.search'));
    //     const allHidden = searchDivs.every(div => div.style.display === 'none');
    //     title.style.display = allHidden ? 'none' : '';
    //   });
    //   checkContactsDisplay();
    // }
    //
    // searchInput.addEventListener('input', searchParagraphs);
    //
    // function checkContactsDisplay() {
    //   const contacts = document.querySelector('.contacts');
    //   const contactsChildren = contacts.children;
    //   let allNone = true;
    //
    //   for (let i = 0; i < contactsChildren.length; i++) {
    //     if (contactsChildren[i].style.display !== 'none') {
    //       const grandchildren = contactsChildren[i].children;
    //       for (let j = 0; j < grandchildren.length; j++) {
    //         if (grandchildren[j].style.display !== 'none') {
    //           allNone = false;
    //           break;
    //         }
    //       }
    //     }
    //   }
    //
    //   if (allNone) {
    //     const contactsnotfound = document.querySelector('.contacts-notfound');
    //     contactsnotfound.innerHTML = 'Nada foi encontrado para essa pesquisa';
    //   } else {
    //     const contactsnotfound = document.querySelector('.contacts-notfound');
    //     contactsnotfound.innerHTML = '';
    //   }
    // }

//end of contact section//

    //location////
    var modalclosed = false;
    const campus_imgs = document.querySelectorAll('.campus-images');
    const modals = document.querySelectorAll('.modal-campus');
    const modalsCloseButton = document.querySelectorAll('.afl__details-close');
    const location = document.querySelector('.location');

    function closeAllModals() {
      let placeholder = document.getElementById('modal-placeholder');
      placeholder.style.display = 'block';
      placeholder.classList.remove('notSelected');
      let modals = document.querySelectorAll('.modal-campus');
      modals.forEach(function (modal) {
        modal.classList.add('notSelected');
      });
      for (let x = 0; x < campus_imgs.length; x++) {
        campus_imgs[x].style.transform = 'scale(1)';
        campus_imgs[x].style.display = 'block';
        campus_imgs[x].classList.remove('selected');
      }

    }

    for (var i = 0; i < modalsCloseButton.length; i++) {
      modalsCloseButton[i].addEventListener('click', function () {
        closeAllModals();
        modalclosed = true;
        location.style.height = '500px';
      })
    }
    //adicionar event listeners para abrir e fechar baseado na imagem de campus clicada.
    for (var i = 0; i < campus_imgs.length; i++) {
      campus_imgs[i].addEventListener('click', function () {
        modalclosed = false;
        if (window.innerWidth < 992) {
          checkWindowWidth();
        }
        for (let x = 0; x < campus_imgs.length; x++) {
          campus_imgs[x].style.transform = 'scale(1)';
          campus_imgs[x].style.display = 'none';
          campus_imgs[x].classList.remove('selected');
        }
        this.style.transform = 'scale(1)'
        this.style.display = 'block'
        this.classList.add('selected')

        var imgvalue = this.getAttribute('value');
        for (var j = 0; j < modals.length; j++) {
          var value = modals[j].getAttribute('value');
          if (imgvalue === value) {
            modals[j].classList.remove("notSelected");
            modals[j].classList.add("Selected");
            let selectedModal = modals[j];

            let location = document.querySelector('.location');
            let intervalID = setInterval(function () {
              location.style.height = selectedModal.offsetHeight  + 'px';
            }, 25);
            setTimeout(function () {
              clearInterval(intervalID);
            }, 400);
          } else {

            modals[j].classList.remove("Selected");
            modals[j].classList.add("notSelected");
          }
        }
      });
    }

    for (var i = 0; i < modals.length; i++) {
      let element = modals[i];
      modals[i].addEventListener('click', function () {
        let location = document.querySelector('.location');
        let intervalID = setInterval(function () {
          if (modalclosed) {
            location.style.transition = '0.4s';
            location.style.height = '300px';
          } else {
            location.style.transition = '0.1s';
            location.style.height = element.offsetHeight - 72 + 'px';
          }
        }, 25);
        setTimeout(function () {
          clearInterval(intervalID);
        }, 400);
      });
    }


    $(window).scroll(function () {
      let placeholder = $('.timeline-placeholder');
      let elementPosition = $('.aftl').offset();
      let elementHeight = $('.aftl').height();

      if ($(window).scrollTop() > elementPosition.top + elementHeight) {
        $('.timeline').removeClass('fixed');
        placeholder.removeClass('activated');
      } else if ($(window).scrollTop() > elementPosition.top) {
        $('.timeline').addClass('fixed');
        placeholder.addClass('activated');
      } else {
        $('.timeline').removeClass('fixed');
        placeholder.removeClass('activated');
      }
    });


    function checkWindowWidth() {
      if (window.innerWidth < 992) {
        setTimeout(function () {
          var modalCampus = document.querySelectorAll('.modal-campus');
          modalCampus.forEach(function (modalcampusitem) {

            modalcampusitem.style.position = 'absolute';
            modalcampusitem.style.left= '0';
            modalcampusitem.style.paddingBottom= '8rem';
          });

        }, 300);
      } else {
        setTimeout(function () {
          var modalCampus = document.querySelectorAll('.modal-campus');
          modalCampus.forEach(function (modalcampusitem) {


            modalcampusitem.style.left= '';
            modalcampusitem.style.paddingBottom= '';
          });

        }, 300);

      }
    }

    window.addEventListener('resize', function (event) {
      checkWindowWidth();
    });


  }

  // $('.grid_wrapper img').on('click', function() {
  // 	console.log($(this).attr('src'))
  // 	console.log($('.grid_box p').text())
  // })
  $('.grid_box').on('click', function() {
    var foto = $(this).find('img:first').attr('src');
    var id = $(this).find('img:first').data('id');

    switch(id) {
      case 1:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="1">Profa. Marcia Cristina Sardá Espindola</h4>
                <p data-id="1" id="teste">
                	Foi eleita e nomeada Reitora em 01/02/2019,
                    devendo o seu mandato estender-se até
                    31/01/2023. Nasceu em Otacílio Costa - SC, no dia
                    20/01/1972, filha de Marlindo Sardá
                    e Amélia Maria Sardá.
                </p>
                <p data-id="1">
                    Graduou-se em Arquitetura e Urbanismo pela
                    Universidade Regional de Blumenau - FURB e
                    tornou-se Mestre em Engenharia Civil (Construção
                    Civil) pela Universidade Federal
                    de Santa Catarina - UFSC.
                </p>
                <p data-id="1">
                	Ingressou como técnica administrativa, no quadro
                    dos servidores da FURB, em 1989, exercendo
                    atividades nos setores de Contabilidade, Divisão de
                    Tecnologia da Informação - DTI e Laboratório de
                    Habilitação da Arquitetura. Em 2005, passou a
                    exercer o cargo de docente do quadro no
                    Departamento de Arquitetura e Urbanismo,
                    lecionando as disciplinas de Ateliê I - Expressão e
                    Representação Gráfica para Arquitetura, Urbanismo
                    e Paisagismo; Ateliê II - Forma, Composição e
                    Espaços na Arquitetura; Ateliê III - Projetos
                    Integrados de Arquitetura, Urbanismo, Paisagismo e
                    Tecnologia; Ateliêr e Maquetaria I, II e III.
                    Sua experiência administrativa compreende a
                    chefia do Departamento de Arquitetura durante
                    dois mandatos (2006-2007 e 2012-2014) e a
                    diretoria do Centro de Ciências Tecnológicas - CCT
                    (2014-2018). Ainda foi Coordenadora do
                    Laboratório de Maquetaria e atuou em diversos
                    Programas e Projetos de Extensão da instituição,
                    Vice-Reitor: João Luiz Gurgel Calvet da Silveira,
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_5c6ee44db58f2.jpg')
        break;
      case 2:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="2">Prof. Mércio Jacobsen</h4>
                <p data-id="2" id="teste">
				Nasceu em Presidente Getúlio - SC, no dia 7 de agosto de 1951, filho de Willy Jacobsen e Helga Jacobsen.
				Cursou o ensino médio no Colégio Pedro II, Blumenau - SC. Estudou na Universidade Regional de Blumenau - FURB,
				obtendo o título de  bacharel em Administração de Empresas. Em seguida, realizou cursos de pós-graduação em nível
				de especialização, Administração de Empresas e  Organização, Sistemas e Métodos, ambos na FURB. Também mestre em
				Educação por esta Instituição.
                </p>
                <p data-id="2">
				Exerceu atividades administrativas de assessor, supervisor e chefe de planejamento industrial, em diversas empresas
				de Blumenau. No magistério, atuou no  Colégio Vale do Itajaí - Pontinho Estudantil e, na FURB, de 1989 a 1999,
				lecionando as disciplinas de Administração de Materiais I e II. Além de ser nomeado reitor, exerceu outros cargos,
				entre eles, o de superintendente de Administração na gestão do reitor Celso Mário Zipf.
				No decorrer de sua gestão, foram, efetivamente, implantados o Plano de Carreira dos Servidores Técnico-Administrativos e
				aprimorado o Plano de Carreira do Magistério Superior. Destinou recursos para ampliação da área construída, aquisição de
				equipamentos de informática, entre outros. Nesta gestão, também foram implantados vários cursos, entre eles, o de Moda-Estilismo
				 e Odontologia.
                </p>
                <p data-id="2">
				A Universidade, neste período, desenvolveu várias parcerias para programas de extensão, dentre os quais, o
				Universidade Solidária  e o Atendimento à Comunidade no Ambulatório Universitário, através do Sistema Único de Saúde.
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_5c6ee44db58f2.jpg')
        break;
      case 3:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="3">Prof. José Tafner</h4>
                <p data-id="3" id="teste">
				1º Mandato - eleito e nomeado reitor da FURB em 16/03/1978, exercendo o cargo até 16/03/1982.
                </p>
                <p data-id="3">
					2º Mandato - eleito e nomeado em 24/10/1986. Exerceu o cargo até 30/3/1989, quando então afastou-se
					para ocupar o cargo de Secretário da Educação do Estado de Santa Catarina. Retornou em 06/04/1990,
					permanecendo até o término da gestão, 24/10/1990.
                </p>
                <p data-id="3">
					Nasceu em Rio dos Cedros - SC, no dia 21 de dezembro de 1940, filho de Ermínio Tafner e Clara Tafner.
					Seus estudos fundamentais foram feitos em Rio dos Cedros e no Colégio São Paulo de Ascurra e, os secundários,
					no Colégio São Luiz, Lavrinhas - SP, de 1957 a 1959. De 1960 a 1962, estudou  na Faculdade de Filosofia, Ciências
					e Letras de Lorena - SP, onde obteve os títulos de bacharel em Pedagogia e Filosofia. Licenciou-se em Pedagogia, pela
					Faculdade Nossa Senhora Medianeira, São Paulo - SP e, em Filosofia, pela Faculdade de Filosofia, Ciências e Letras de
					Ijuí- RS. Fez pós-graduação em nível de mestrado em Educação, no Instituto de Estudos Avançados em Educação, da Fundação
					Getúlio Vargas, Rio de Janeiro - RJ, de 1974 a 1975.Em 1995, defendeu tese de mestrado, no curso de mestrado em Ensino
					Superior da FURB, na área de Avaliação Educacional. No magistério, atuou em diversos Colégios onde lecionou a disciplina
					de Desenho e Matemática, entre outras. De 1995 a 1997, atuou como diretor do Ensino Superior de Santa Catarina, na Secretaria
					de Estado da Educação, implantando o Programa Magister (104 cursos de licenciatura, nas mais diferentes áreas, atendendo,
					gratuitamente, a mais de 5 mil professores da rede estadual e municipal) e, no período de 1997 a 2002, foi membro do Conselho
					Estadual de Educação de Santa Catarina. Na FURB, exerceu atividades administrativas e de docência, de 1970 a 1995, entre elas,
					a de diretor da Faculdade de Filosofia, Ciências e Letras. Lecionou disciplinas de História da Educação, Psicometria, Medidas
					Educacionais, Metodologia Científica, Planejamento Educacional e Estatística Aplicada à Educação. Durante sua gestão, ampliou-se
					consideravelmente o espaço físico e o número de vagas oferecidas na Instituição, implantando-se, também, o curso de Medicina, em 1989.
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_49f7468757651.jpg')
        break;
      case 4:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="4">Prof. João Natel Pollonio Machado</h4>
                <p data-id="4" id="teste">
					Nasceu em Santa Mariana - PR, no dia 23 de junho de 1960, filho de Manoel Machado Filho e Herminia Pollonio Machado.
					Graduou-se em Medicina, pela Universidade Federal do Paraná - UFPR, em 20/07/1988. Realizou residência médica em Neurologia,
					também na UFPR, em 31/01/1991. Mestre em Ciências Médicas - concentração em Clínica Médica, pela Universidade Federal de Santa
					Catarina - UFSC, em 21/10/2002. Doutor em Neurologia, pela Universidade de São Paulo - USP, em 01/03/2010.
                </p>
                <p data-id="4">
					Professor do quadro da FURB desde 1995, lecionando nos cursos de graduação de Medicina e Fisioterapia, disciplinas de Neuroanatomia,
					Neurologia, Semiologia Médica, Internato em Clínica Médica.
                </p>
                <p data-id="4">
					Sua experiência administrativa compreende a chefia do Departamento de Medicina, por um mandato no período de agosto/2002 a junho/2004
					e outro mandato no período de abril/2009 a junho/2010; e a coordenação do Colegiado do Curso de Medicina por dois mandatos agosto/1998
					a agosto/2002. Foi membro do Conselho de Centro de Ciências da Saúde, do Conselho de Ensino, Pesquisa e Extensão - CEPE e da Câmara de
					Ensino. Membro da Academia Brasileira de Neurologia, da American Academy of Neurology e pelos trabalhos em neuropatia periférica foi
					agraciado, em 2002, com o prêmio de Mérito Cientifico da Associação Catarinense. Em 2014, recebeu o título honorífico de Cidadão Blumenauense
					 em sessão solene na Câmara de Vereadores de Blumenau.
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_4f99d07351a82.jpg')
        break;
      case 5:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="5">Prof. Celso Mário Zipf</h4>
                <p data-id="5" id="teste">
					Nasceu em Itajaí - SC, no dia 15 de agosto de 1933, filho de José Zipf e Maria Pessoa Zipf. Realizou seus estudos fundamental
					e médio no Colégio Santo Antônio, Blumenau - SC. Mais adiante, obteve o título de bacharel em Ciências Econômicas, pela Faculdade
					de Ciências Econômicas de Blumenau, hoje FURB.
                </p>
                <p data-id="5">
					Exerceu as atividades de funcionário do Banco do Brasil, secretário adjunto da Secretaria Estadual da Indústria e Comércio, diretor do Banco
					do Estado de Santa Catarina, presidente do Conselho de Desenvolvimento da Região Metropolitana do Vale do Itajaí, assessor de diversas empresas,
					entre outras.
                </p>
                <p data-id="5">
					Na FURB, atuou de 1969 a 1999, em cargos administrativos como chefe do Departamento de Administração e, na docência, lecionando as disciplinas
					de Introdução à Administração e Teoria Geral da Administração.
					Durante sua gestão,  iniciaram-se os trabalhos de mudança no regime jurídico da Instituição. O Fundo Previdenciário próprio dos servidores da FURB
					dava seus primeiros passos.
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_49f7489b102f6.jpg')
        break;
      //AQUI
      case 6:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="6">Prof. Ignacio Ricken</h4>
                <p data-id="6" id="teste">
					Foi nomeado e eleito reitor da FURB em 16/03/1974, exercendo o cargo até 16/03/1978.
					Nasceu em Rio Fortuna - SC, no dia 4 de julho 1938, filho de Gabriel Ricken e Maria Vandresen Ricken. Concluiu seus estudos
					secundários em Curitiba, no Colégio Estadual do Paraná. Licenciou-se em Letras pela Universidade Federal do Paraná - UFPR. Na Alemanha,
					pós-graduou-se, em nível de doutorado de 1960 a 1966, em Letras e Ciências Políticas pela Universidade de Marburg/Lahn. Na Universidade
					Federal de Santa Catarina - UFSC cursou mestrado em Administração, área de concentração Administração Universitária - 1980/1981.
					Ao retornar da Europa, além das atividades docentes, exerceu atividades na Pontíficia Universidade Católica do Paraná PUC-PR e, em seguida,
					a de secretário geral e reitor da Fundação Universidade Regional de Blumenau - 1974/1978. Foi, ainda, vice-presidente da Associação Catarinense
					das Fundações Educacionais - ACAFE. Transferindo-se para Florianópolis, foi diretor executivo da Fundação de Amparo à Pesquisa e Extensão
					Universitária da Universidade Federal de Santa Catarina FAPEU/UFSC e, em seguida, pró-reitor de Pesquisa e Desenvolvimento na Universidade Estadual
					de Santa Catarina - UDESC.
                </p>
                <p data-id="6">
					No magistério, atuou no Colégio Senhor Bom Jesus - 1957/1960, no Colégio Martinus - 1966/1969, e no curso de Letras da PUC-PR - 1968/1969, todos
					em Curitiba - PR. Na FURB, lecionou as disciplinas de Língua e Literatura Alemã, Linguística e Teoria da Literatura. Em Blumenau, exerceu, também,
					cargo diretivo no Instituto Brasil-Alemanha (ICBA/Instituto GOETHE). Em Florianópolis exerceu igualmente, a docência na UFSC e na UDESC.
					De 1978 a 1996 participou como consultor de inúmeras comissões do Conselho Federal de Educação e do Ministério da Educação. Notadamente comissões
					de reconhecimento (credenciamento) de universidades, sendo que, em 1996, integrou a Comissão do MEC que analisou os processos de criação de universidades
					em tramitação, quando da extinção do CFE, Desde 1980, exerceu atividades de consultoria universitária em mais de duas dezenas de universidades brasileiras
					- em Santa Catarina e em outros estados.
					Como reitor da FURB, deve ser destacado o seu empenho no processo de institucionalização da FURB como Universidade, implantando e reconhecendo nove cursos
					de graduação, dentre eles, os de Engenharia Civil e Química, Educação Física e o primeiro curso de Informática no estado de Santa Catarina de Processamento de
					Dados, criado no segundo semestre de 1974.
                </p>
                <p data-id="6">
					Mediante gestões junto à alta administração da Rede Ferroviária Federal, obteve-se a doação à FURB das instalações da mesma, localizadas no bairro Itoupava
					Seca , hoje instalado o câmpus 2. Foi, também, objeto de doação, a Estação Experimental da Souza Cruz em Gaspar. Do Banco Bamerindus obteve-se, mediante pagamento
					simbólico, o primeiro computador (UNIVAC) da FURB. Para garantir a expansão física da Universidade, contratou-se, em 1977, o planejamento físico do Câmpus (plano diretor)
					no bairro Passo Manso. O trabalho de institucionalização da FURB como Universidade com o protocolo do primeiro reconhecimento (credenciamento) da FURB, em dezembro 1977,
					cujo êxito se obteve em 1986, quando o ex-reitor prof. Ricken exercia atividades de assessoria da Instituição. O prof. Ignacio Ricken permaneceu vinculado à FURB até o ano de 1990.
				<p data-id="6">
					Obs: este Histórico foi elaborado pelo próprio Ignácio Ricken
				</p>
				<p data-id="6">
					Vice-Reitor: Renato de Mello (16/03/1974 - 16/03/1978)
				</p>
				<p data-id="6">
					Vice-Reitor: Pedro Reis Júnior (16/03/1977 - 16/03/1978)

                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_49f749b941155.jpg')
        break;
      case 7:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="7">Prof. Mércio Jacobsen</h4>
                <p data-id="7" id="teste">
					Foi eleito e nomeado Reitor da FURB em 27/10/2006, exercendo o cargo até 26/10/2010. Nasceu em Blumenau - SC, no dia
					14 de janeiro de 1966, filho de Genésio Deschamps e Irma Deschamps.
                </p>
                <p data-id="7">
					Graduou-se como Engenheiro Eletricista, pela Universidade Federal de Santa Catarina - UFSC, em 1987. Mestre e doutor em Engenharia
					Elétrica pela UFSC, respectivamente em 1990 e 1999. Especializou-se em Empreendedorismo na Engenharia, em 2001, através de um curso
					de pós-graduação voltado para a formação de professores para disseminação da cultura empreendedora na área tecnológica.
                </p>
                <p data-id="7">
					Professor do quadro da FURB desde 1990, lecionando nos curso de graduação em Engenharia Elétrica, Engenharia de Telecomunicações,
					Engenharia de Produção e Ciências da Computação. Lecionou, igualmente, nos cursos de especialização em Qualidade de Conservação de
					Energia Elétrica, Telemática e Automação Industrial. Atou também como professor orientador nos mestrados em Engenharia Elétrica.
					Engenharia Ambiental e Desenvolvimento Regional.
                </p>
                <p data-id="7">
					Sua experiência administrativa compreende a chefia do Departamento de Engenharia Elétrica e de Telecomunicações, durante dois mandatos;
					a coordenação do Colegiado do Curso de Engenharia Elétrica, por um mandato; e a direção do Instituto de Pesquisas Tecnológicas de Blumenau,
					hoje Instituto FURB, em duas gestões, 1994-1995 e 1999-2001. Ainda, foi membro instituidor da Fundação Fritz Müller da qual já foi presidente.
					Foi avaliador institucional credenciado pelo Ministério de Educação.
                </p>
				<p data-id="7">
					<b>Vice-Reitor:</b> Romero Fenili
				</p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_4a03268aed165.jpg')
        break;
      case 8:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="8">Prof. Arlindo Bernart</h4>
                <p data-id="8" id="teste">
					Foi eleito e nomeado reitor da FURB em 16/3/1982, exercendo o cargo até 24/10/1986.
                </p>
                <p data-id="8">
					Nasceu em Antônio Prado - RS, no dia 11 de junho de 1931, filho de Benjamim Bernart e Adélia Mortari Bernart.
					Realizou seus estudos secundários no Colégio Nossa Senhora do Rosário, Porto Alegre - RS, e no Colégio Diocesano,
					Lages - SC. Cursou a Escola de Comércio Santo Antônio, Lages - SC, onde obteve o título de contador. Posteriormente,
					estudou na Faculdade de Direito da Pontifícia Universidade Católica - PUC-RS, obtendo o título de  bacharel em Ciências
					Jurídicas e Sociais. Também mestre em Direito pela Universidade Federal de Santa Catarina - UFSC.
                </p>
                <p data-id="8">
					Exerceu as atividades de contador, bancário, advogado, juiz de direito, coordenador da Escola de Magistratura do Estado de Santa Catarina,
					consultor do MEC na área jurídica, entre outros. Atuou na FURB de 1968 a 2001 exercendo atividades administrativas, dentre elas, a de diretor
					da Faculdade de Ciências Jurídicas e do Centro de Ciências Jurídicas. Lecionou disciplinas de Direito Processual Civil, Direito Comercial,
					Direito Internacional Público, Direito Comercial Internacional, Teoria Geral do Estado, Introdução ao Estudo do Direito, Ética e Ética
					Profissional.
                </p>
				<p data-id="8">
					Durante sua gestão, as Faculdades que compunham a FURB foram unificadas, e em 13/02/1986, a FURB foi reconhecida como Universidade e ganhou um
					prédio próprio para a Biblioteca.
				</p>
				<p data-id="8">
					Arlindo Bernart recebeu muitas homenagens de diversas entidades. Seus préstimos e dedicação para com a FURB foram reconhecidos, em  fevereiro
					de 2002, quando o Conselho Universitário conferiu-lhe o título de “Professor Emérito”.
				</p>
				<p data-id="8">
					<b>Vice-Reitor:</b> Bráulio Maria Schloegel
				</p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_49f749844a7fa.jpg')
        break;
      case 9:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="9">Padre Orlando Maria Murphy</h4>
                <p data-id="9" id="teste">
					Foi eleito e nomeado reitor da FURB em 18/03/1970, exercendo o cargo até 16/03/1974.
                </p>
                <p data-id="9">
					Nasceu em Indaial - SC, no dia 2 de fevereiro de 1931, filho de Eduardo Antônio Murphy e Emma Murphy. Realizou seus estudos no Seminário
					Coração de Jesus, Corupá - SC. Graduou-se em Filosofia, no Convento Sagrado Coração de Jesus, em Brusque - SC. Licenciou-se em Teologia,
					pela Universidade Gregoriana de Roma e, em Ciências Sociais e Políticas, pela Universidade Católica de Lovaina, da Bélgica. Em seguida,
					cursou pós-graduação em Teologia Moral, também pela Universidade Gregoriana de Roma, onde obteve o título de doutor.
                </p>
                <p data-id="9">
					Entre suas atividades profissionais, destacam-se a de diretor dos Colégios São Luiz e Honório Miranda, ambos de Brusque - SC. Também foi
					diretor da Faculdade Educacional de Brusque - SC, membro do Conselho Estadual de Educação, no período de 1971 a 1977. No magistério, atuou
					em diversas Escolas nos ensinos fundamental e médio, lecionando  diversas disciplinas, entre outras funções.
                </p>
                <p data-id="9">
					No Convento Sagrado Coração de Jesus, de Brusque - SC, lecionou as disciplinas de Filosofia do Ser e Filosofia do Agir (Ética). Na FURB,
					atuou como docente, de 1964 a 1985, lecionando as disciplinas de Sociologia Geral, Estudo dos Problemas Brasileiros e Filosofia do Direito.
                </p>
                <p data-id="9">
					Durante sua gestão, o Conselho Federal, autorizou  o funcionamento de mais uma Faculdade, a de Engenharia, somando-se, em 1973, quatro
					Faculdades. Nesse período, foram acrescidos os Blocos D e E à área edificada da FURB.
                </p>
                <p data-id="9">
					Orlando faleceu em 17 de fevereiro de 1985.
                </p>
                <p data-id="9">
					<b>Vice-Reitor:</b> Lorival Hari Hübner Saade
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_4a0deee7ef3ce.jpg')
        break;
      case 10:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="10">Prof. Egon José Schramm</h4>
                <p data-id="10" id="teste">
					1º Mandato - eleito e nomeado reitor da FURB em 26/10/1998, exercendo o cargo até 24/10/2002.
                </p>
                <p data-id="10">
					2º Mandato - reconduzido ao cargo em 25/10/2002, exercendo o cargo até 26/10/2006.
                </p>
                <p data-id="10">
					Nasceu em Gaspar - SC, no dia 8 de julho de 1951, filho de Sílvio Schramm e Maria Edith Schramm. Graduou-se em Ciências Biológicas,
					pela Universidade Regional de Blumenau - FURB em 1975. Exerceu atividades docentes desde 1972, lecionando no Colégio Estadual Frei
					Godofredo - Gaspar, até 1974. Atuou como professor no Conjunto Educacional Pedro II - Blumenau, até 1976, um ano após concluir sua graduação.
                </p>
                <p data-id="10">
					Em continuidade aos estudos, cursou mestrado na Universidade Federal do Rio Grande do Sul - UFRGS, concluindo em 1979.
                </p>
                <p data-id="10">
					Retornando ao Vale do Itajaí, iniciou, em 1979, atividades na FURB como professor de dedicação exclusiva. Lecionou disciplinas de
					Prática de Ensino em Ciências, Genética e Evolução, e Genética Vegetal, do Departamento de Ciências Naturais. Atuou como chefe do
					Departamento de Ciências Naturais de 1982 a 1984. Foi o primeiro Coordenador e Organizador da Escola Técnica do Vale do Itajaí,
					mantida pela FURB - Etevi, de 1980 a 1986. Elegeu-se como primeiro diretor do Centro de Ciências Exatas e Naturais, para o período
					de 1986 a 1990, tendo sido reeleito até 1994.
                </p>
                <p data-id="10">
					Continuando os estudos, especializou-se em Biologia de Peixes, pela Universidade de Gödölö - Hungria, em 1989. E, na FURB, foi o
					co-fundador e um dos idealizadores da Fundação de Piscicultura Integrada do Vale do Itajaí - FUNPIVI, em 1988, localizada na
					sede de Timbó. Foi membro presidente do conselho deliberativo dessa entidade.
                </p>
                <p data-id="10">
					Mostrando-se interessado em Administração Universitária, especializou-se nessa temática, na Universidade de Quebec - Canadá, em 1993.
                </p>
                <p data-id="10">
					Foi eleito e nomeado vice-reitor da FURB, na gestão de 1994-1998. Elegeu-se para a próxima administração, de 1998-2002, como reitor
					(primeiro mandato). Foi reconduzido ao cargo para gestão 2002-2006 (segundo mandato).
                </p>
                <p data-id="10">
					Com compromisso sério, a FURB, nesse período, ampliou os cursos de graduação e de curta duração; mestrados próprios, entre outros; priorizando
					áreas como: ambiental, tecnológica e de saúde. Visando à integração entre pesquisa, ensino e extensão, primando pela qualidade do ensino, com
					ampliação da titulação docente, bem como dos espaços físicos e estrutura tecnológica. Atualizando métodos pedagógicos, absorvendo novas tecnologias
					para a relação professor-aluno. Assim, ampliou-se a inserção da FURB em questões que dizem respeito a políticas públicas, desenvolvimento regional
					e gestão ambiental.
                </p>
                <p data-id="10">
					Foi, também, representante da Associação de Reitores das Universidades Estaduais e Municipais - ABRUEM, no conselho deliberativo do CRUB - Conselho
					de Reitores das Universidades Brasileiras até 15/07/2004. Eleito presidente da Associação Catarinense das Fundações Educacionais - ACAFE, em junho
					de 2002, reconduzido ao cargo para mais um ano no dia 30/05/2003 permanecendo até 2/6/2004. Em 07/05/2005 foi nomeado conselheiro do Conselho
					Estadual de Educação de Santa Catarina.
                </p>
                <p data-id="10">
					Egon José Schramm faleceu em 30/06/2018.
                </p>
                <p data-id="10">
					1º e 2º Mandatos - Vice-Reitor: Rui Rizzo
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_49f7485415344.jpg')
        break;
      case 11:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="11">Prof. João Joaquim Fronza</h4>
                <p data-id="11" id="teste">
					Foi nomeado reitor em exercício da FURB, em 30/03/1989, em substituição ao prof. José Tafner. Exerceu o cargo até 06/04/1990.
                </p>
                <p data-id="11">
					Nasceu em Rodeio - SC, no dia 23 de dezembro de 1922, filho de Joaquim Fronza e Luiza Bonezzi Fronza. Licenciou-se em História e
					Geografia, pela Faculdade de Filosofia, Ciências e Letras da Universidade do Paraná, Curitiba - PR. Atuou como docente, de 1951 a 1978,
					em diversos estabelecimentos de ensino fundamental e médio, lecionando as disciplinas de História e Geografia.
                </p>
                <p data-id="11">
					Na FURB, exerceu atividades de 1968 a 1991, lecionando as disciplinas de Estudo dos Problemas Brasileiros, Cultura Brasileira, História
					da Educação e Sociologia da Educação, nos cursos de Letras, Pedagogia, Matemática, Química e História Natural.
                </p>
                <p data-id="11">
					João Joaquim Fronza, faleceu em 06/06/1991.
                </p>
                <p data-id="11">
					Vice-Reitor:  não há menção ao cargo de Vice-Reitor nesse período.
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_4a0def2b5e4e5.jpg')
        break;
      //aqui
      case 12:
        console.log(id)
        $('.escondido').empty()
        var conteudo =
          `
				<h4 data-id="12">Prof. Martinho Cardoso da Veiga</h4>
                <p data-id="12" id="teste">
					Foi eleito e nomeado reitor da FURB em 31/12/1968, exercendo o cargo até 18/03/1970.
                </p>
                <p data-id="12">
					Nasceu em Blumenau - SC, no dia 14 de maio de 1912, filho de Luiz Silveira da Veiga e Maria Amália Cardoso Veiga. Seus estudos secundários,
					realizou no Colégio São Luiz de Tolosa, Rio Negro - PR, de 1925 a 1931. E de 1943 a 1945, cursou a Escola de Comércio Santo Antônio, em Blumenau
					- SC, onde obteve o título de contador.
                </p>
                <p data-id="12">
					De 1947 a 1950, estudou na Faculdade de Ciências Econômicas do Paraná, obtendo o título de  bacharel em Ciências Econômicas. Em seguida, estudou
					na Faculdade de Direito da Universidade de Santa Catarina - UFSC, onde lhe foi conferido o título de bacharel em Direito.
                </p>
                <p data-id="12">
					Exerceu as atividades de contador, economista e advogado, em diversas empresas de Blumenau. No magistério, atuou na  Escola  Técnica de Comércio de
					1946 a 1964. Na FURB, de 1964 a 1974, lecionando as disciplinas de Economia Geral e do Brasil, Direito Comercial e Fiscal, Contabilidade Geral e
					Estrutura e Análise de Balanço.
                </p>
                <p data-id="12">
					Martinho Cardoso da Veiga, também foi vereador na época da criação da Faculdade. Por suas mãos, o Projeto de criação chegou até a Câmara  Municipal
					de Blumenau (1963), onde, posteriormente, foi aprovado e resultou na Lei que cria a Faculdade de Ciências Econômicas de Blumenau, mais tarde,
					Fundação Universidade Regional de Blumenau.
                </p>
                <p data-id="12">
					Martinho faleceu no ano de 1974. Seus préstimos e dedicação, para com a FURB, são, carinhosamente, reconhecidos e lembrados, com uma escultura de seu
					busto, exposta até 2004 em frente à entrada principal da Instituição - bloco A. Depois foi removida para à frente da Biblioteca Universitária - que leva seu nome.
                </p>
                <p data-id="12">
					Vice-Reitor de Administrativo: Milton Pompeu da Costa Ribeiro
                </p>
                <p data-id="12">
					Vice-Reitor de Ensino: José Fernandes da Câmara Canto Rufino
                </p>
				`
        $('.escondido').append(conteudo)
        $('.foto_reitor').attr('src', 'https://www.furb.br/novo//arquivos/galeria_reitor/thumb1_4a0df6b5d8b7d.jpg')
        break;
    }
  })
});
